/**
 * Модель для работы с отчётом "Пребывание в зонах"
 */

import { createModel } from '@rematch/core';
import { RootModel } from './index';
import { saveAs } from 'file-saver';

import { IId, IOffice, IArea, IReportStayInAreas, IEmployeeShort } from './types';
import setStartEndOfDay from '../utils/setStartEndOfDay';

import MapsService from '../services/MapsService';
import UsersService from '../services/UsersService';
import ReportService from '../services/ReportService';
import moment from 'moment';

interface IData {
  offices: IOffice[];
  employees: IEmployeeShort[];
  areas: IArea[];
}

interface IList {
  data: IReportStayInAreas[] | null;
  pagesCount: number;
}

interface IState {
  data: IData;
  list: IList;
}

const initialState: IState = {
  data: {
    offices: [],
    employees: [],
    areas: []
  },
  list: {
    data: null,
    pagesCount: 0
  }
};

export const reportStayInAreas = createModel<RootModel>()({
  state: initialState,
  reducers: {
    setData(state: IState, payload: IData): IState {
      return { ...state, data: { ...state.data, ...payload } };
    },
    resetDataAreas(state: IState): IState {
      const { areas } = initialState.data;

      return { ...state, data: { ...state.data, areas } };
    },
    setList(state: IState, payload: IList): IState {
      return { ...state, list: payload };
    },
    resetList(state: IState): IState {
      return {
        ...state,
        list: {
          data: null,
          pagesCount: 0
        }
      };
    },
    reset(): IState {
      return { ...initialState };
    }
  },
  effects: () => ({
    async getData() {
      try {
        const [
          {
            data: { data: offices }
          },
          { data: employees }
        ] = await Promise.all([MapsService.getOffices(), UsersService.getAllEmployeesShort()]);

        this.setData({
          offices,
          employees
        });
      } catch (error) {
        return error;
      }
    },
    async getDataAreas(id: IId) {
      try {
        const {
          data: { areas }
        } = await MapsService.get(id);

        this.setData({ areas });
      } catch (error) {
        return error;
      }
    },
    async getList(params: any, rootState?: any) {
      const { from, to } = params;
      try {
        const { data } = await ReportService.getStayInAreas({
          ...params,
          ...{ from: moment(from).format(), to: moment(to).format() }
        });

        this.setList(data);
      } catch (error) {
        return error;
      }
    },
    async exportList(params: any, rootState?: any) {
      const { from, to } = params;

      // const cloneParams = setStartEndOfDay(params, ['from', 'to']);

      try {
        const { data } = await ReportService.getCsvStayInAreas({
          ...params,
          ...{ from: moment(from).format(), to: moment(to).format() }
        });

        saveAs(data, `Отчет по пребыванию в зонах за период ${from} - ${to}.csv`);
      } catch (error) {
        return error;
      }
    }
  })
});
